import { Enumerable, OrieConfig } from "../types/internal";
import { logger } from "../utils/logger";
import { createCart } from "./cart";
import { createCheckout } from "./checkout";
import { createClient } from "./client";
import { createEvent } from "./event";
import { createEventDiscount } from "./event-discount";
import { createProduct } from "./product";
import { createProfile } from "./profile";
import { createService } from "./service";
import { createSession } from "./session";
import { createSubscription } from "./subscription";

export const createOrie = (config: OrieConfig) => {
  const client = createClient(config, logger);

  return {
    product: createProduct(client),
    event: createEvent(client),
    service: createService(client),
    profile: createProfile(client),
    cart: createCart(client),
    checkout: createCheckout(client),
    eventDiscount: createEventDiscount(client),
    session: createSession(client),
    subscription: createSubscription(client),
    client: {
      setCurrency: (currency: string) => {
        client.updateClient({ currency });
      },
      setUser: (user: string) => {
        client.updateClient({ user });
      },
      setPublishableKey: (publishableKey: string) => {
        client.updateClient({ publishableKey });
      },
      update(config: Partial<OrieConfig>) {
        client.updateClient(config);
      },
    },
  };
};
